var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-end q-gutter-x-sm"},[_c('action-show-button',{attrs:{"label":"ویرایش","url":_vm.couponEditPageLink}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }